<script setup lang="ts">
import NavbarComponent from "@/components/NavbarComponent.vue";
import {onMounted, onUnmounted, ref, watch} from "vue";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "./components/FooterImpressum.vue";
import "@/assets/styles/main.css"
import {useRoute} from "vue-router";

const route = useRoute();
const siteName = "KFZ Musterwerkstatt";
const fallbackDescription = "Unverbindliche Website-Demo für eine moderne Kfz-Werkstatt. Alle Namen, Kontaktdaten und Angaben sind fiktiv.";

const setMeta = (selector: string, attribute: "name" | "property", key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonical = (href: string) => {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
};

watch(
    () => route.fullPath,
    () => {
      const title = route.meta.title as string || siteName;
      const description = route.meta.description as string || fallbackDescription;
      const canonical = `${window.location.origin}${route.path}`;

      document.title = title;
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:title"]', "property", "og:title", title);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
      setMeta('meta[property="og:url"]', "property", "og:url", canonical);
      setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
      setCanonical(canonical);
    },
    {immediate: true}
);

const isMobile = ref(window.innerWidth <= 768);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

</script>

<template>
  <div class="app">
    <div class="demo-ribbon" role="note" aria-label="Hinweis zur Demo-Website">
      <span class="demo-ribbon-badge">Demo</span>
      <span>Unverbindliche Website-Demo</span>
      <span class="demo-ribbon-detail">Keine reale Werkstatt · Alle Angaben sind fiktiv</span>
    </div>
    <!-- Desktop Navbar -->
    <NavbarComponent v-if="!isMobile"/>
    <SidebarComponent v-else/>

    <router-view/>
    
    <FooterImpressum/>
  </div>
</template>
